/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Gsoa_ProductCatalog_Products } from '../models/Gsoa_ProductCatalog_Products';
import type { Gsoa_Recommender_Entities } from '../models/Gsoa_Recommender_Entities';
import type { Gsoa_Recommender_EntitiesBuy } from '../models/Gsoa_Recommender_EntitiesBuy';
import type { Gsoa_Recommender_Terms } from '../models/Gsoa_Recommender_Terms';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GsoaRecommenderService {
    /**
     * @returns void
     * @throws ApiError
     */
    public static getApiVGsoaRecommenderIsAlive({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/recommender/isAlive',
            path: {
                'apiVersion': apiVersion,
            },
        });
    }
    /**
     * The operation returns XXX to the most commonly purchased customer products.
     * @returns Gsoa_Recommender_EntitiesBuy Successful loading.
     * @throws ApiError
     */
    public static getCommonBuyProducts({
        houseNumber,
        apiVersion = 1,
        page,
        pageSize = 30,
    }: {
        houseNumber: number,
        apiVersion?: number,
        /**
         * Page order number (starts at 0)
         */
        page?: number,
        /**
         * The number of items per page
         */
        pageSize?: number,
    }): CancelablePromise<Array<Gsoa_Recommender_EntitiesBuy>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/recommender/houses/{houseNumber}/commonbuy',
            path: {
                'apiVersion': apiVersion,
                'houseNumber': houseNumber,
            },
            query: {
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * The operation returns XXX to the most commonly purchased customer products.
     * @returns Gsoa_ProductCatalog_Products OK
     * @throws ApiError
     */
    public static getCommonBuyProductsCatalog({
        houseNumber,
        apiVersion = 1,
        useRebatesVersion,
        listedProductOnly = true,
        fields,
        filterProductsCatalog,
        page,
        pageSize = 50,
    }: {
        houseNumber: number,
        apiVersion?: number,
        useRebatesVersion?: number,
        listedProductOnly?: boolean,
        /**
         * String represents list of fields split by delimiters ;.
         * <details>
         * <summary><b>Supported attributes - examples:</b></summary>
         * <p>
         * vanr;ean;productTagIds;warengroup;name;productInHouse;unitId;placementOrder;imgIcon;imgThumbnail;modified;brand;description;contains;imgDetail;allergens;nutritionValues;producer;storage;alias;rabatNumber;originalRebateId </br>
         * vanr;ean;modified </br>
         * vanr;ean;productInHouse </br>
         * </p>
         * </details>
         */
        fields?: string,
        /**
         * <b>Filtering on response attributes</b>
         * <p>
         * <details>
         * <summary>Supported operators:</summary>
         * <p><i>in</i> - checks if attribute equals one of posibilities. Case sensitive when literal attribute.</p>
         * </details>
         * <details>
         * <summary>Supported attributes - examples:</summary>
         * <p>
         * producerId:in Abc,def,ghi </br>
         * productCategories:in Abc,def,ghi </br>
         * countriesOfOrigin:in Abc,def,ghi </br>
         * commonBrandId:in Abc,def,ghi </br>
         * ean:in Abc,def,ghi </br>
         * vanr:in Abc,def,ghi </br>
         * productTagIds:in Abc,def,ghi </br>
         * rabatNumber:in Abc,def,ghi </br>
         * originalRebateId:in Abc,def,ghi </br>
         * </p>
         * </details>
         * Combinations possible, concatenation with ";;" means logical AND. E.g.: producerId:in Abc,def,ghi;;productCategories:in Abc,def,ghi
         * </p>
         */
        filterProductsCatalog?: string,
        /**
         * Page order number (starts at 0)
         */
        page?: number,
        /**
         * The number of items per page
         */
        pageSize?: number,
    }): CancelablePromise<Gsoa_ProductCatalog_Products> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/recommender/houses/{houseNumber}/commonbuyProductsCatalog',
            path: {
                'apiVersion': apiVersion,
                'houseNumber': houseNumber,
            },
            query: {
                'useRebatesVersion': useRebatesVersion,
                'listedProductOnly': listedProductOnly,
                'fields': fields,
                'filter-productsCatalog': filterProductsCatalog,
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * The operation returns frequently purchased customer products for the purpose of the shopping list
     * @returns Gsoa_Recommender_EntitiesBuy Successful loading.
     * @throws ApiError
     */
    public static getOftenBuyProducts({
        houseNumber,
        apiVersion = 1,
        page,
        pageSize = 30,
    }: {
        houseNumber: number,
        apiVersion?: number,
        /**
         * Page order number (starts at 0)
         */
        page?: number,
        /**
         * The number of items per page
         */
        pageSize?: number,
    }): CancelablePromise<Array<Gsoa_Recommender_EntitiesBuy>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/recommender/houses/{houseNumber}/oftenbuy',
            path: {
                'apiVersion': apiVersion,
                'houseNumber': houseNumber,
            },
            query: {
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * The operation returns frequently purchased customer products for the purpose of the shopping list
     * @returns Gsoa_ProductCatalog_Products OK
     * @throws ApiError
     */
    public static getOftenBuyProductsCatalog({
        houseNumber,
        apiVersion = 1,
        useRebatesVersion,
        listedProductOnly = true,
        fields,
        filterProductsCatalog,
        page,
        pageSize = 50,
    }: {
        houseNumber: number,
        apiVersion?: number,
        useRebatesVersion?: number,
        listedProductOnly?: boolean,
        /**
         * String represents list of fields split by delimiters ;.
         * <details>
         * <summary><b>Supported attributes - examples:</b></summary>
         * <p>
         * vanr;ean;productTagIds;warengroup;name;productInHouse;unitId;placementOrder;imgIcon;imgThumbnail;modified;brand;description;contains;imgDetail;allergens;nutritionValues;producer;storage;alias;rabatNumber;originalRebateId </br>
         * vanr;ean;modified </br>
         * vanr;ean;productInHouse </br>
         * </p>
         * </details>
         */
        fields?: string,
        /**
         * <b>Filtering on response attributes</b>
         * <p>
         * <details>
         * <summary>Supported operators:</summary>
         * <p><i>in</i> - checks if attribute equals one of posibilities. Case sensitive when literal attribute.</p>
         * </details>
         * <details>
         * <summary>Supported attributes - examples:</summary>
         * <p>
         * producerId:in Abc,def,ghi </br>
         * productCategories:in Abc,def,ghi </br>
         * countriesOfOrigin:in Abc,def,ghi </br>
         * commonBrandId:in Abc,def,ghi </br>
         * ean:in Abc,def,ghi </br>
         * vanr:in Abc,def,ghi </br>
         * productTagIds:in Abc,def,ghi </br>
         * rabatNumber:in Abc,def,ghi </br>
         * originalRebateId:in Abc,def,ghi </br>
         * </p>
         * </details>
         * Combinations possible, concatenation with ";;" means logical AND. E.g.: producerId:in Abc,def,ghi;;productCategories:in Abc,def,ghi
         * </p>
         */
        filterProductsCatalog?: string,
        /**
         * Page order number (starts at 0)
         */
        page?: number,
        /**
         * The number of items per page
         */
        pageSize?: number,
    }): CancelablePromise<Gsoa_ProductCatalog_Products> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/recommender/houses/{houseNumber}/oftenbuyProductsCatalog',
            path: {
                'apiVersion': apiVersion,
                'houseNumber': houseNumber,
            },
            query: {
                'useRebatesVersion': useRebatesVersion,
                'listedProductOnly': listedProductOnly,
                'fields': fields,
                'filter-productsCatalog': filterProductsCatalog,
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Product search in the shopping center catalog according to entered identifiers / full text and additional information
     * @returns any Search complete.
     * @throws ApiError
     */
    public static searchProducts({
        houseNumber,
        apiVersion = 1,
        page,
        pageSize = 30,
        filter,
        fields,
    }: {
        houseNumber: number,
        apiVersion?: number,
        /**
         * Page order number (starts at 0)
         */
        page?: number,
        /**
         * The number of items per page
         */
        pageSize?: number,
        /**
         * <b>Filtering on response attributes</b>
         * <p>
         * <details>
         * <summary><b>Supported operators:</b></summary>
         * <p>
         * <i>contains</i> - Value types: checks if attribute contains substring. Case Insensitive. Collection of value types: check if collection contains value. Case sensitive
         * <i>in</i> - checks if attribute equals one of posibilities. Case sensitive when literal attribute.
         * <i>eq</i> - checks if attribute is equals. Case sensitive when literal attribute.
         * </p>
         * </details>
         * <details>
         * <summary><b>Supported attributes - examples:</b></summary>
         * <p>
         * SearchText:contains ab </br>
         * ReturnEntities:in Product <span class="prop-type">Enum:[ Product, Category, GeneralizedProduct, CommonBrand ]</span> </br>
         * SearchByGeneralizedProduct:eq Abc </br>
         * </p>
         * </details>
         * Combinations possible, concatenation with ";;" means logical AND. E.g.: SearchText:contains ab;;ReturnEntities:in Abc,def,ghi
         * </p>
         */
        filter?: string,
        /**
         * String represents list of fields split by delimiters ;.
         * <details>
         * <summary><b>Supported attributes - examples:</b></summary>
         * <p>
         * Type;ID;LastChange </br>
         * </p>
         * </details>
         */
        fields?: string,
    }): CancelablePromise<{
        entities?: Array<Gsoa_Recommender_Entities>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/recommender/houses/{houseNumber}/search',
            path: {
                'apiVersion': apiVersion,
                'houseNumber': houseNumber,
            },
            query: {
                'page': page,
                'pageSize': pageSize,
                'filter': filter,
                'fields': fields,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * ThProduct search in the shopping center catalog according to entered identifiers / full text and additional information
     * @returns Gsoa_ProductCatalog_Products OK
     * @throws ApiError
     */
    public static searchProductsCatalog({
        houseNumber,
        filter,
        apiVersion = 1,
        clientId,
        useRebatesVersion,
        listedProductOnly = true,
        fields,
        filterProductsCatalog,
        page,
        pageSize = 50,
        autocomplete = false,
    }: {
        houseNumber: number,
        /**
         * String to filter
         */
        filter: string,
        apiVersion?: number,
        /**
         * Anonymous client ID stable within the user session
         */
        clientId?: string,
        useRebatesVersion?: number,
        listedProductOnly?: boolean,
        /**
         * String represents list of fields split by delimiters ;.
         * <details>
         * <summary><b>Supported attributes - examples:</b></summary>
         * <p>
         * vanr;ean;productTagIds;warengroup;name;productInHouse;unitId;placementOrder;imgIcon;imgThumbnail;modified;brand;description;contains;imgDetail;allergens;nutritionValues;producer;storage;alias;rabatNumber;originalRebateId </br>
         * vanr;ean;modified </br>
         * vanr;ean;productInHouse </br>
         * </p>
         * </details>
         */
        fields?: string,
        /**
         * <b>Filtering on response attributes</b>
         * <p>
         * <details>
         * <summary>Supported operators:</summary>
         * <p><i>in</i> - checks if attribute equals one of posibilities. Case sensitive when literal attribute.</p>
         * </details>
         * <details>
         * <summary>Supported attributes - examples:</summary>
         * <p>
         * producerId:in Abc,def,ghi </br>
         * productCategories:in Abc,def,ghi </br>
         * countriesOfOrigin:in Abc,def,ghi </br>
         * commonBrandId:in Abc,def,ghi </br>
         * ean:in Abc,def,ghi </br>
         * vanr:in Abc,def,ghi </br>
         * productTagIds:in Abc,def,ghi </br>
         * rabatNumber:in Abc,def,ghi </br>
         * originalRebateId:in Abc,def,ghi </br>
         * </p>
         * </details>
         * Combinations possible, concatenation with ";;" means logical AND. E.g.: producerId:in Abc,def,ghi;;productCategories:in Abc,def,ghi
         * </p>
         */
        filterProductsCatalog?: string,
        /**
         * Page order number (starts at 0)
         */
        page?: number,
        /**
         * The number of items per page
         */
        pageSize?: number,
        /**
         * True for autocomplete, false for full search
         */
        autocomplete?: boolean,
    }): CancelablePromise<Gsoa_ProductCatalog_Products> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/recommender/houses/{houseNumber}/searchProductsCatalog',
            path: {
                'apiVersion': apiVersion,
                'houseNumber': houseNumber,
            },
            query: {
                'filter': filter,
                'clientId': clientId,
                'useRebatesVersion': useRebatesVersion,
                'listedProductOnly': listedProductOnly,
                'fields': fields,
                'filter-productsCatalog': filterProductsCatalog,
                'page': page,
                'pageSize': pageSize,
                'autocomplete': autocomplete,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Search terms by incomplete text and additional information
     * @returns Gsoa_Recommender_Terms Suggestions complete.
     * @throws ApiError
     */
    public static getSuggestions({
        houseNumber,
        apiVersion = 1,
        page,
        pageSize = 7,
        filter,
    }: {
        houseNumber: number,
        apiVersion?: number,
        /**
         * Page order number (starts at 0)
         */
        page?: number,
        /**
         * The number of items per page
         */
        pageSize?: number,
        /**
         * <b>Filtering on response attributes</b>
         * <p>
         * <details>
         * <summary><b>Supported operators:</b></summary>
         * <p>
         * <i>contains</i> - Value types: checks if attribute contains substring. Case Insensitive. Collection of value types: check if collection contains value. Case sensitive
         * <i>in</i> - checks if attribute equals one of posibilities. Case sensitive when literal attribute.
         * <i>eq</i> - checks if attribute is equals. Case sensitive when literal attribute.
         * </p>
         * </details>
         * <details>
         * <summary><b>Supported attributes - examples:</b></summary>
         * <p>
         * SearchText:contains ab </br>
         * ReturnEntities:in Product <span class="prop-type">Enum:[ Product, Category, GeneralizedProduct, CommonBrand ]</span> </br>
         * SearchByGeneralizedProduct:eq Abc </br>
         * </p>
         * </details>
         * Combinations possible, concatenation with ";;" means logical AND. E.g.: SearchText:contains ab;;ReturnEntities:in Abc,def,ghi
         * </p>
         */
        filter?: string,
    }): CancelablePromise<Gsoa_Recommender_Terms> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/recommender/houses/{houseNumber}/suggestions',
            path: {
                'apiVersion': apiVersion,
                'houseNumber': houseNumber,
            },
            query: {
                'page': page,
                'pageSize': pageSize,
                'filter': filter,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
}
